(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-replica"] && !Shopify.designMode) return;
  try {
    
/* MOBILE article: hammer the gap on <main> (no Liquid) */
(function hardOffMainGap(){
  function isArticleMobile(){
    return document.body && document.body.classList.contains('template-article') &&
           window.matchMedia('(max-width:768px)').matches;
  }
  function nuke(){
    if (!isArticleMobile()) return;
    document.body.style.setProperty('gap','0','important');
    document.body.style.setProperty('row-gap','0','important');
    document.documentElement.style.setProperty('--header-bottom-position','0px');
    document.body.style.setProperty('--header-bottom-position','0px','important');
    var m = document.querySelector('main') || document.getElementById('MainContent');
    if (m){
      m.style.setProperty('padding-top','0','important');
      m.style.setProperty('margin-top','0','important');
    }
  }
  nuke();
  window.addEventListener('load', nuke, {passive:true});
  document.addEventListener('shopify:section:load', nuke);
  var i=0, t=setInterval(function(){ nuke(); if(++i>20) clearInterval(t); }, 150);
  new MutationObserver(nuke).observe(document.documentElement, { attributes:true, childList:true, subtree:true });
})();

/* Mobile spacing normalization within the section root */
(function () {
  function apply(root) {
    if (!root) return;
    var isMobile = window.matchMedia('(max-width: 767.98px)').matches;
    var header   = root.querySelector('.ar__header');
    var title    = root.querySelector('h1.ar__title');

    if (isMobile) {
      root.style.setProperty('--header-offset', '12px', 'important');
      if (header) header.style.setProperty('transform', 'none', 'important');
      if (title)  title.style.setProperty('margin-top', '0', 'important');
    } else {
      root.style.removeProperty('--header-offset');
      if (header) header.removeAttribute('style');
      if (title)  title.style.removeProperty('margin-top');
    }
  }

  function runAll() {
    var roots = document.querySelectorAll('.article-replica.ar--deck');
    for (var r = 0; r < roots.length; r++) apply(roots[r]);
  }

  runAll();
  window.addEventListener('resize', runAll);
  document.addEventListener('shopify:section:load', runAll);
})();

/* Mini slideshow controls */
(function() {
  var slideshows = document.querySelectorAll('.ar__ms');
  for (var s = 0; s < slideshows.length; s++) {
    (function(ms) {
      var track  = ms.querySelector('.ar__ms-track');
      var slides = ms.querySelectorAll('.ar__ms-slide');
      var prev   = ms.querySelector('.ar__ms-prev');
      var next   = ms.querySelector('.ar__ms-next');
      var dots   = ms.querySelectorAll('.ar__ms-dot');
      var live   = ms.querySelector('.ar__ms-live');
      if (!track || slides.length === 0) return;

      var idx = 0;

      function announce() {
        if (live) { live.textContent = 'Slide ' + (idx + 1) + ' of ' + slides.length; }
      }

      function update() {
        track.style.transform = 'translate3d(' + (-idx * 100) + '%,0,0)';
        if (prev) prev.disabled = (idx === 0);
        if (next) next.disabled = (idx === slides.length - 1);

        for (var d = 0; d < dots.length; d++) {
          var isActive = (d === idx);
          if (isActive) dots[d].classList.add('is-active'); else dots[d].classList.remove('is-active');
          dots[d].setAttribute('aria-current', isActive ? 'true' : 'false');
        }
        announce();
      }

      if (prev) prev.addEventListener('click', function(){ if (idx > 0){ idx--; update(); }});
      if (next) next.addEventListener('click', function(){ if (idx < slides.length - 1){ idx++; update(); }});
      for (var d = 0; d < dots.length; d++) (function(i){
        dots[i].addEventListener('click', function(){ idx = i; update(); });
      })(d);

      update();
    })(slideshows[s]);
  }
})();

/* Mobile: kill header padding injected at runtime */
(function(){
  function killMainTopPad(){
    if (!window.matchMedia('(max-width: 767.98px)').matches) return;
    if (!document.body.classList.contains('template-article')) return;
    var main = document.getElementById('MainContent');
    if (main) main.style.setProperty('padding-top', '0px', 'important');
    document.documentElement.style.setProperty('--header-height', '0px');
    document.documentElement.style.setProperty('--header-bottom-position', '0px');
  }
  document.addEventListener('DOMContentLoaded', killMainTopPad);
  window.addEventListener('resize', killMainTopPad, {passive:true});
  document.addEventListener('shopify:section:load', killMainTopPad);
})();

/* Mobile: belt-and-suspenders header gap killer */
(function(){
  function nukeHeaderGap(){
    if (!window.matchMedia('(max-width: 767.98px)').matches) return;
    if (!document.body.classList.contains('template-article')) return;
    var main = document.getElementById('MainContent');
    if (main) {
      main.style.setProperty('padding-top', '0px', 'important');
      main.style.setProperty('margin-top', '0px', 'important');
    }
    document.documentElement.style.setProperty('--header-bottom-position', '0px');
    document.documentElement.style.setProperty('--header-height', '0px');
  }
  document.addEventListener('DOMContentLoaded', nukeHeaderGap);
  window.addEventListener('resize', nukeHeaderGap, {passive:true});
  document.addEventListener('shopify:section:load', nukeHeaderGap);
})();

/* DESKTOP ONLY, page-scoped: Confine horizontal scrolling to the article rail on /blogs/news/the-bag-of-man */
(function(){
  var mqDesktop = window.matchMedia('(min-width: 990px)');
  var enabled = false, unsubs = [];

  function isTargetPage(){
    return /\/blogs\/news\/the\-bag\-of\-man(?:\/|$|\?)/i.test(location.pathname);
  }

  function on(el, ev, fn, opts){ if (el) { el.addEventListener(ev, fn, opts||false); unsubs.push(function(){ el.removeEventListener(ev, fn, opts||false); }); } }

  function enable(){
    if (enabled) return;
    if (!isTargetPage() || !mqDesktop.matches) return;

    var rail = document.querySelector('.article-replica.ar--deck .ar__stack');
    if (!rail) return;

    enabled = true;

    // Ensure page doesn’t scroll (CSS also enforces this)
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    // Redirect wheel/trackpad deltas to horizontal scroll of the rail
    function redirectWheel(e){
      if (!rail.contains(e.target)) return;
      var dx = Math.abs(e.deltaY) >= Math.abs(e.deltaX) ? e.deltaY : e.deltaX;
      rail.scrollLeft += dx;
      e.preventDefault();
    }
    on(rail, 'wheel', redirectWheel, { passive:false });

    // Block page-level wheel outside the rail
    on(window, 'wheel', function(e){
      if (!rail.contains(e.target)) e.preventDefault();
    }, { passive:false });

    // Keyboard arrows/pg/space drive the rail
    on(window, 'keydown', function(e){
      var k = e.key;
      if (k === 'ArrowRight' || k === 'PageDown' || k === ' ') { rail.scrollLeft += 80; e.preventDefault(); }
      if (k === 'ArrowLeft'  || k === 'PageUp')                { rail.scrollLeft -= 80; e.preventDefault(); }
      if (k === 'Home') { rail.scrollLeft = 0; e.preventDefault(); }
      if (k === 'End')  { rail.scrollLeft = rail.scrollWidth; e.preventDefault(); }
    });
  }

  function disable(){
    if (!enabled) return;
    enabled = false;
    while (unsubs.length) { try{ unsubs.pop()(); }catch(_){} }
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  function sync(){
    if (isTargetPage() && mqDesktop.matches) enable(); else disable();
  }

  document.addEventListener('DOMContentLoaded', sync);
  window.addEventListener('load', sync);
  mqDesktop.addEventListener('change', sync);
  document.addEventListener('shopify:section:load', sync);
})();

  } catch(e) { console.error(e); }
})();
})();
